import React, { useEffect, useState } from 'react';
import './supportNetworksSection.scss';
import { ReactComponent as SupportNetworksScheme } from "./components/SupportNetworksScheme.svg";
import { ReactComponent as SupportNetworksSchemeAdaptive } from "./components/SupportNetworksSchemeAdaptive.svg";

const SupportNetworksSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="supportNetworks">
			<div className="supportNetworks__content">
				<div className="supportNetworks__content_data">
					<div className="supportNetworks__content_data_title">
						<h2>The networks we support</h2>
						<span>Experience convenience and high-speed performance in key networks with large trading volumes.</span>
					</div>
					<div className="supportNetworks__content_data_button">
						<button
							className="secondButton"
							onClick={() => window.open('https://t.me/NFD_degens_community')}
						>
							<span>More info</span>
						</button>
					</div>
				</div>
				<div className="supportNetworks__content_scheme">
					{
						width > 767 ? (
							<SupportNetworksScheme />
						) : (
							<SupportNetworksSchemeAdaptive />
						)
					}
				</div>
			</div>
		</div>
	);
};

export default SupportNetworksSection;